module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MDUiIHZpZXdCb3g9IjAgMCAxNDQwIDUwNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNTAuOTcxN0MwIDUwLjk3MTcgNDE5LjQ1NyAyLjI1MzcgNzAyLjUgMC4wNzE1NDA0Qzk5OC44MDggLTIuMjEyOSAxNDQwIDUwLjk3MTcgMTQ0MCA1MC45NzE3VjUwNUgwVjUwLjk3MTdaIiBmaWxsPSIjNDY1MTZCIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_bottom.svg
// module id = D0dG
// module chunks = 1